/* eslint-disable import/no-default-export */
import { Action, actionCreator } from 'app/gamma/src/util/actions';
import { createReducer } from 'app/gamma/src/util/reducers';

export const getDeleteBoardPopoverName = (idBoard: string) =>
  `DELETE_BOARD_POPOVER_${idBoard}`;

export const getLeaveBoardPopoverName = (idBoard: string) =>
  `LEAVE_BOARD_POPOVER_${idBoard}`;

export const getReopenBoardPopoverName = (idBoard: string) =>
  `REOPEN_BOARD_POPOVER_${idBoard}`;

export const FREE_TEAMS_OUT_OF_SPACE_POPOVER = Symbol(
  'FREE_TEAMS_OUT_OF_SPACE_POPOVER',
);

export const SHARE_TEMPLATE_POPOVER = Symbol('SHARE_TEMPLATE_POPOVER');

export const SHOW_POPOVER = Symbol('ui/SHOW_POPOVER');
const CLOSE_POPOVER = Symbol('ui/CLOSE_POPOVER');
const CLOSE_POPOVERS = Symbol('ui/CLOSE_POPOVERS');

export type PopoverName = symbol | string;

interface PopoverPayload {
  name: PopoverName;
}

export type ShowPopoverAction = Action<typeof SHOW_POPOVER, PopoverPayload>;
type ClosePopoverAction = Action<typeof CLOSE_POPOVER, PopoverName>;
type ClosePopoversAction = Action<typeof CLOSE_POPOVERS, void>;

export const showPopover = actionCreator<ShowPopoverAction>(SHOW_POPOVER);
export const closePopover = actionCreator<ClosePopoverAction>(CLOSE_POPOVER);
export const closePopovers = actionCreator<ClosePopoversAction>(CLOSE_POPOVERS);

export type PopoversState = PopoverName[];

const initialState: PopoversState = [];

export default createReducer(initialState, {
  [SHOW_POPOVER](state, { payload: { name } }: ShowPopoverAction) {
    return state.includes(name) ? state : [...state, name];
  },

  [CLOSE_POPOVER](state, { payload: name }: ClosePopoverAction) {
    // NOTE: If you have an element in a popover that gets hidden after you
    // click on it this may be called. This happens because the popover
    // component thinks that a component from outside the popover was
    // clicked on, which causes it to close.
    // To fix this add e.preventDefault() to your onClick handler
    return state.filter((popover) => popover !== name);
  },

  [CLOSE_POPOVERS]() {
    return initialState;
  },
});
